<template>
  <ml-dialog
    width="600px"
    ref="dialogRef"
    :title="title"
    :btnLoading="btnLoading"
    :showSubmitBtn="!formDisable"
    :showSecondaryBtn="type !== 'view'"
    :showThridBtn="type !== 'view'"
    secondaryText="AI诊断"
    submitText="提交"
    thridText="保存草稿"
    @click-secondary="aiDiagnoseHandle"
    @click-submit="submitHandle"
    @click-close="closeHandle"
    @click-thrid="saveDraftHandle"
  >
    <template #body>
      <div class="form-box">
        <ml-form
          style="width: 100%"
          labelWidth="130px"
          :model="submitReportForm"
          ref="bindDialogFormRef"
          :rules="dialogFormRef"
          :disabled="formDisable"
        >
          <ml-input
            prop="deviceId"
            placeholder="请输入设备"
            label="设备:"
            v-model="submitReportForm.deviceName"
            v-if="formDisable"
          />
          <ml-select
            v-else
            prop="deviceId"
            placeholder="请选择设备"
            :options="equipmentManageata"
            :filterable="true"
            label="设备:"
            keyName="deviceId"
            labelName="deviceName"
            valueName="deviceId"
            v-model="submitReportForm.deviceId"
            v-model:node="deviceNode"
            @change="changeEquipmentHandle"
          />

          <ml-input
            prop="propertyType"
            placeholder="请输入资产类别"
            label="资产类别:"
            v-model="submitReportForm.propertyType"
            :disabled="true"
          />

          <ml-input
            prop="deviceType"
            placeholder="请输入设备类型"
            label="设备类型:"
            v-model="submitReportForm.deviceType"
            :disabled="true"
          />
          <!-- <ml-date-picker
            prop="startTime"
            placeholder="请选择开始时间"
            label="开始时间:"
            type="datetime"
            :disable="formDisable"
            v-model="submitReportForm.startTime"
          />
          <ml-date-picker
            prop="endTime"
            placeholder="请选择结束时间"
            label="结束时间:"
            type="datetime"
            v-model="submitReportForm.endTime"
          /> -->
          <ml-input
            prop="content"
            placeholder="请描述维修过程及结果"
            label="处理过程及结果"
            type="textarea"
            :rows="5"
            v-model="submitReportForm.content"
          />
          <el-form-item>
            <template #label>
              <span>安全作业附件</span>
              <el-tooltip content="上传的图片必须符合涉水、涉电、高空、道路作业中的一项要求" placement="top">
                <i class="el-icon-question" style="cursor: pointer; margin-left: 4px"></i>
              </el-tooltip>
            </template>
            <ml-upload
              multiple
              autoUpload
              :showFileList="false"
              :action="action"
              :data="{ linkType: 'error', type: 1 }"
              :headers="{ Authorization: toKen }"
              name="files"
              @on-success="onSafetyUploadSuccess"
            >
              <el-button size="medium" icon="el-icon-circle-plus-outline" type="primary">
                上传附件
              </el-button>
            </ml-upload>
            <ml-list
              fileName="fileName"
              :showDelete="!formDisable"
              :showDown="formDisable"
              :list="submitReportForm.safetyAttachVos"
              :showPreview="true"
              :textMaxWidth="250"
            />
          </el-form-item>
          <el-form-item label="日常作业附件" prop="dailyAttachVos">
            <ml-upload
              multiple
              autoUpload
              :showFileList="false"
              :action="action"
              :data="{ linkType: 'error', type: 0 }"
              :headers="{ Authorization: toKen }"
              name="files"
              @on-success="onDailyUploadSuccess"
            >
              <el-button size="medium" icon="el-icon-circle-plus-outline" type="primary">
                上传附件
              </el-button>
            </ml-upload>
            <ml-list
              fileName="fileName"
              :showDelete="!formDisable"
              :showDown="formDisable"
              :list="submitReportForm.dailyAttachVos"
              :showPreview="true"
              :textMaxWidth="250"
            />
          </el-form-item>
          <el-form-item label="备品备件消耗">
            <el-radio-group v-model="submitReportForm.partFlag">
              <el-radio label="N">无</el-radio>
              <el-radio label="Y">有</el-radio>
            </el-radio-group>
          </el-form-item>

          <ml-select
            v-if="submitReportForm.partFlag === 'Y'"
            prop="partId"
            placeholder="请选择备品备件"
            :options="partOptions"
            label="备品备件:"
            keyName="partId"
            labelName="partName"
            valueName="partId"
            v-model="submitReportForm.partId"
            @change="changeHandle"
          />

          <ml-input-number
            v-if="submitReportForm.partFlag === 'Y'"
            prop="partCount"
            placeholder="请输入数量"
            :min="0"
            :precision="0"
            label="数量"
            v-model="submitReportForm.partCount"
          />
        </ml-form>
      </div>
    </template>
  </ml-dialog>
  <!-- AI诊断结果弹窗 -->
  <ml-dialog
    v-if="showAIResult"
    title="AI诊断结果"
    width="600px"
    ref="aiResultDialogRef"
    :showSubmitBtn="false"
    :showSecondaryBtn="false"
    secondaryText="关闭"
    @click-secondary="showAIResult = false"
    @click-close="showAIResult = false"
  >
    <template #body>
      <div class="ai-result-content" v-html="aiResult"></div>
    </template>
  </ml-dialog>
</template>

<script>
import { computed, nextTick, onMounted, reactive, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { BASEURL, FILEUPLOADURL } from '@API'
import { getTabberData } from '@/utils'
export default {
  name: 'submitDialog',
  props: {
    conf: {
      type: Object,
      default() {
        return {}
      }
    },
    btnCode: {
      type: String,
      default: ''
    },
    companyId: {
      type: String,
      default: ''
    },
    projectId: {
      type: String,
      default: ''
    },
    errorInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    sourData: {
      type: Object,
      default() {
        return {}
      }
    },
    type: {
      type: String,
      default: 'edit'
    },
    errorId: {
      type: String,
      default: ''
    }
  },
  emits: ['success', 'close'],
  setup(props, context) {
    const { commit, dispatch, getters } = useStore()
    const toKen = computed(() => getters.getToken)
    const dialogRef = ref()
    const title = ref('提交报告')
    const maxStock = ref(props.type === 'view' ? Number(props.sourData.partCount) : 0)
    const formDisable = ref(props.type === 'view' ? true : false)
    watch(
      () => props.btnCode,
      () => {}
    )

    const dialogData = reactive({
      buttonCode: props.btnCode,
      procInsId: props.conf && props.conf.taskDto && props.conf.taskDto.processInstanceId,
      taskId: props.conf && props.conf.taskDto && props.conf.taskDto.id,
      variables: props.conf && props.conf.variables,
      comment: '',
      toUserId: '',
      customParamJson: '',
      fileList: [],
      nodeId: props.conf && props.conf.id,
      businessParamJson: '',
      created: props.conf && props.conf.taskDto && props.conf.taskDto.created,
      formConf: props.conf.formConf
    })
    let btnLoading = ref(false)

    // 上传附件
    const action = ref(`${BASEURL}${FILEUPLOADURL}`)
    // 安全作业附件上传成功
    const onSafetyUploadSuccess = files => {
      if (files.data) {
        const items = files.data
        const isSafetyRemark = remark => typeof remark === 'string' && remark.startsWith('type_')
        const compliantItems = items.filter(item => isSafetyRemark(item.remark))
        const hasNonCompliant = items.some(item => !isSafetyRemark(item.remark))
        if (hasNonCompliant) {
          commit('setError', {
            status: true,
            title: '',
            message: '上传的图片必须符合涉水、涉电、高空、道路作业中的一项要求',
            type: 'error'
          })
        }
        if (compliantItems.length > 0) {
          submitReportForm.safetyAttachVos = [
            ...submitReportForm.safetyAttachVos,
            ...compliantItems
          ]
        }
      }
    }
    // 日常作业附件上传成功
    const onDailyUploadSuccess = files => {
      if (files.data) {
        submitReportForm.dailyAttachVos = [...submitReportForm.dailyAttachVos, ...files.data]
      }
    }
    const bindDialogFormRef = ref()
    const partOptions = ref([])
    const submitReportForm = reactive({
      content: props.type === 'view' ? props.sourData.content : '',
      safetyAttachVos:
        props.type === 'view'
          ? (props.sourData.attachVos || []).filter(item => typeof item.remark === 'string' && item.remark.startsWith('type_'))
          : [],
      dailyAttachVos:
        props.type === 'view'
          ? (props.sourData.attachVos || []).filter(item => !(typeof item.remark === 'string' && item.remark.startsWith('type_')))
          : [],
      attachVos: [],
      partFlag: props.type === 'view' ? props.sourData.partFlag : 'N',
      partId: props.type === 'view' ? props.sourData.partId : '',
      partCount: props.type === 'view' ? Number(props.sourData.partCount) : 0,
      deviceId: props.type === 'view' ? props.sourData.deviceId : '',
      propertyType: props.type === 'view' ? props.sourData.propertyType : '',
      deviceType: props.type === 'view' ? props.sourData.deviceType : '',
      deviceName: props.type === 'view' ? props.sourData.deviceName : ''
    })
    // 校验
    const isPartFlagY = () => submitReportForm.partFlag === 'Y' && !!submitReportForm.partId
    const dialogFormRef = {
      content: [{ required: true, message: '请输入描述', trigger: 'blur' }],
      dailyAttachVos: [{ required: true, message: '请上传日常作业附件', trigger: 'change' }],
      partFlag: [{ required: true, message: '请选择是否有备品备件', trigger: 'blur' }],
      partId: [{ validator: isPartFlagY, message: '请选择备品备件', trigger: 'blur' }],
      deviceId: [{ required: true, message: '请选择设备', trigger: 'blur' }],
      propertyType: [{ required: true, message: '请选择资产类别', trigger: 'blur' }],
      deviceType: [{ required: true, message: '请选择设备类型', trigger: 'blur' }]
    }

    // 设备下拉列表
    const equipmentManageata = ref([])
    // 设备选中信息
    const deviceNode = ref({})

    const getEquipmentManageata = async () => {
      const projectParams = {
        projectId: props.projectId,
        companyId: props.companyId
      }

      const { data } = await getTabberData(dispatch, 'fetchGetDeviceInfos', projectParams)
      equipmentManageata.value = data || []
    }

    const changeEquipmentHandle = () => {
      submitReportForm.propertyType = deviceNode.value.propertyType
      submitReportForm.deviceType = deviceNode.value.deviceType
      submitReportForm.deviceName = deviceNode.value.deviceName
    }

    let aiResult = ref('')
    const aiResultDialogRef = ref(null)
    const showAIResult = ref(false)

    const aiDiagnoseHandle = () => {
      if (!submitReportForm.deviceId) {
        commit('setError', {
          status: true,
          title: '',
          message: '请选择设备',
          type: 'warning'
        })
        return
      }
      let question = `设备名称:${deviceNode.value.deviceName};${
        props.errorInfo.model ? `设备规格:${props.errorInfo.model};` : ''
      }故障描述:${props.errorInfo.errorDesc}`
      dispatch('fetchGetAiChatRequest', { question: question }).then(res => {
        console.log(res)
        if (res.code === 200) {
          aiResult.value = res.data
          showAIResult.value = true
          nextTick(() => {
            aiResultDialogRef.value.showDialog = true
          })
        }
      })
    }

    const submitHandle = () => {
      bindDialogFormRef.value.CustomFormRef.validate().then(() => {
        if (submitReportForm.partFlag === 'Y' && !submitReportForm.partCount) {
          commit('setError', {
            status: true,
            title: '',
            message: '备品消耗数量不能为空',
            type: 'warning'
          })
          return
        }
        submitReportForm.attachVos = [
          ...submitReportForm.safetyAttachVos,
          ...submitReportForm.dailyAttachVos
        ]
        btnLoading.value = true
        dialogData.fileList = submitReportForm.attachVos
        dialogData.comment = submitReportForm.content
        dialogData.businessParamJson = JSON.stringify(submitReportForm)
        dispatch('fetchButtonClickRequest', dialogData)
          .then(res => {
            btnLoading.value = false
            if (res && res.code === 200) {
              commit('setError', {
                status: true,
                title: res.message,
                message: '处理成功...',
                type: 'success'
              })
              context.emit('success')
            }
          })
          .catch(() => {
            btnLoading.value = false
          })
      })
    }
    const closeHandle = () => {
      context.emit('close')
    }
    const changeHandle = () => {
      if (partOptions.value.length > 0) {
        const item = partOptions.value.find(d => d.partId === submitReportForm.partId)
        if (item) {
          maxStock.value = item.realStock - item.frozenStock
        } else {
          maxStock.value = 0
        }
        if (submitReportForm.partCount > maxStock.value) {
          submitReportForm.partCount = maxStock.value
        }
      }
    }

    // 草稿相关功能 - 单条记录暂存
    const hasDraft = ref(false)

    // 加载草稿内容
    const loadDraft = async () => {
      if (!props.errorId) return
      try {
        const res = await dispatch('fetchSelectByErrorId', { errorId: props.errorId })
        if (res.code === 200 && res.data) {
          hasDraft.value = true
          // 将草稿内容填充到表单
          submitReportForm.content = res.data.content || ''
          submitReportForm.safetyAttachVos = (res.data.attachVos || []).filter(
            item => typeof item.remark === 'string' && item.remark.startsWith('type_')
          )
          submitReportForm.dailyAttachVos = (res.data.attachVos || []).filter(
            item => !(typeof item.remark === 'string' && item.remark.startsWith('type_'))
          )
          submitReportForm.partFlag = res.data.partFlag || 'N'
          submitReportForm.partId = res.data.partId || ''
          submitReportForm.partCount = res.data.partCount || 0
          submitReportForm.deviceId = res.data.deviceId || ''
          submitReportForm.propertyType = res.data.propertyType || ''
          submitReportForm.deviceType = res.data.deviceType || ''
          submitReportForm.deviceName = res.data.deviceName || ''

          // 如果草稿中有设备信息,需要同步更新deviceNode
          if (res.data.deviceId) {
            const device = equipmentManageata.value.find(d => d.deviceId === res.data.deviceId)
            if (device) {
              deviceNode.value = device
            }
          }
        } else {
          hasDraft.value = false
        }
      } catch (error) {
        console.error('加载草稿失败:', error)
        hasDraft.value = false
      }
    }

    // 保存草稿
    const saveDraftHandle = async () => {
      try {
        bindDialogFormRef.value.CustomFormRef.validate().then(async () => {
          if (submitReportForm.partFlag === 'Y' && !submitReportForm.partCount) {
            commit('setError', {
              status: true,
              title: '',
              message: '备品消耗数量不能为空',
              type: 'warning'
            })
            return
          }

          if (!props.errorId) {
            commit('setError', {
              status: true,
              title: '',
              message: '故障ID不存在,无法保存草稿',
              type: 'warning'
            })
            return
          }

          btnLoading.value = true
          const params = {
            errorId: props.errorId,
            partId: submitReportForm.partId || '',
            content: submitReportForm.content,
            endTime: new Date().toISOString().slice(0, 19).replace('T', ' '),
            deviceId: submitReportForm.deviceId,
            partFlag: submitReportForm.partFlag,
            attachVos: [...submitReportForm.safetyAttachVos, ...submitReportForm.dailyAttachVos],
            partCount: submitReportForm.partCount || 0,
            deviceName: submitReportForm.deviceName,
            deviceType: submitReportForm.deviceType,
            propertyType: submitReportForm.propertyType
          }

          const res = await dispatch('fetchDraftErrorSubmitRecord', params)
          btnLoading.value = false
          if (res.code === 200) {
            commit('setError', {
              status: true,
              title: '',
              message: '草稿保存成功',
              type: 'success'
            })
            hasDraft.value = true
          }
        })
      } catch (error) {
        btnLoading.value = false
        console.error('保存草稿失败:', error)
      }
    }

    onMounted(async () => {
      await nextTick()
      const sparePartsData = await getTabberData(dispatch, 'fetchGetspareParts', {
        companyId: props.companyId
      })
      partOptions.value = sparePartsData.data || []
      await getEquipmentManageata()
      // 加载草稿内容
      if (props.errorId && props.type !== 'view') {
        await loadDraft()
      }
    })
    return {
      dialogRef,
      dialogFormRef,
      title,
      dialogData,
      submitHandle,
      closeHandle,
      btnLoading,
      toKen,
      action,
      onSafetyUploadSuccess,
      onDailyUploadSuccess,
      submitReportForm,
      bindDialogFormRef,
      partOptions,
      formDisable,
      maxStock,
      changeHandle,
      deviceNode,
      equipmentManageata,
      changeEquipmentHandle,
      aiDiagnoseHandle,
      aiResult,
      aiResultDialogRef,
      showAIResult,
      // 草稿相关
      hasDraft,
      saveDraftHandle
    }
  }
}
</script>

<style lang="scss" scoped>
.form-box {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}
</style>
